export enum dashboardTypes {
    LOADING = "LOADING",
    GET_DASHBOARD_LIST = "GET_DASHBOARD_LIST",
    GET_DASHBOARD_USER = "GET_DASHBOARD_USER",
    SET_DASHBOARD_TABLE_DATA = "SET_DASHBOARD_TABLE_DATA",
    SET_DASHBOARD_HISTORIQUE_DATA = "SET_DASHBOARD_HISTORIQUE_DATA",
}
  
export default dashboardTypes;